import userSlice from './reducer'

export default userSlice.reducer
